import { Mic } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import type { UseVoiceComposer } from "../hooks/use-voice-composer";

/**
 * Idle mic trigger. Presentational only: callers own the `useVoiceComposer` state, so this can be
 * rendered only in idle toolbar/composer states without rules-of-hooks concerns.
 */
export function VoiceTriggerButton({
  voice,
  className,
}: {
  voice: Pick<UseVoiceComposer, "start" | "unavailable" | "isTranscribing">;
  className?: string;
}) {
  return (
    <Tooltip>
      <TooltipTrigger render={<span />}>
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          className={cn("text-muted-foreground", className)}
          onClick={voice.start}
          disabled={voice.unavailable || voice.isTranscribing}
          aria-label={voice.isTranscribing ? "Transcribing voice input" : "Start voice input"}
        >
          {voice.isTranscribing ? <Spinner className="size-4" /> : <Mic className="size-4" />}
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top">
        {voice.isTranscribing ? "Transcribing..." : "Start voice input"}
      </TooltipContent>
    </Tooltip>
  );
}
